import React, { useEffect, useState } from 'react';
import { useLang } from '../context/LanguageContext';
import { socials } from '../data/mock';
import { Menu, X } from 'lucide-react';

const openBooking = () => window.open(socials.instagram, '_blank', 'noopener,noreferrer');

const Header = () => {
  const { lang, toggle, t } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = [
    { id: 'piercing', label: t.nav.piercing },
    { id: 'bijoux', label: t.nav.bijoux },
    { id: 'grillz', label: t.nav.grillz },
    { id: 'strass', label: t.nav.strass },
    { id: 'prothese-acier', label: t.nav.protheseAcier },
    { id: 'prothese-titane', label: t.nav.protheseTitane },
    { id: 'realisations', label: t.nav.realisations },
    { id: 'reviews', label: t.nav.reviews },
    { id: 'contact', label: t.nav.contact },
  ];

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-white/95 backdrop-blur-md border-b border-[#E8E2D5]' : 'bg-transparent'}`}
    >
      <div className="container-tight flex items-center justify-between" style={{ height: scrolled ? 72 : 88 }}>
        <button onClick={() => scrollTo('home')} className="flex items-center gap-3 group">
          <div className="w-9 h-9 border border-[#1A1A1A] flex items-center justify-center transition-colors duration-300 group-hover:bg-[#1A1A1A]">
            <span className="display text-[18px] leading-none group-hover:text-white transition-colors">D</span>
          </div>
          <div className="leading-tight text-left">
            <div className="display text-[20px] tracking-wide">DEVIL TATTOOZ</div>
            <div className="text-[9px] tracking-[0.32em] uppercase text-[#8A8275]">{lang === 'fr' ? 'Maison de piercing' : 'House of piercing'}</div>
          </div>
        </button>

        <nav className="hidden xl:flex items-center gap-6 2xl:gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className="text-[11px] tracking-[0.22em] 2xl:tracking-[0.28em] uppercase font-medium text-[#1A1A1A] hover:text-[#957340] transition-colors whitespace-nowrap"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden xl:flex items-center gap-5 ml-6">
          <button onClick={toggle} className="flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase font-medium whitespace-nowrap">
            <span className={lang === 'fr' ? 'text-[#1A1A1A]' : 'text-[#8A8275]'}>FR</span>
            <span className="text-[#8A8275]">/</span>
            <span className={lang === 'en' ? 'text-[#1A1A1A]' : 'text-[#8A8275]'}>EN</span>
          </button>
          <button onClick={openBooking} className="btn-primary">
            {t.nav.book}
          </button>
        </div>

        <button className="xl:hidden" onClick={() => setOpen(!open)} aria-label="menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div className={`xl:hidden overflow-hidden transition-all duration-500 ${open ? 'max-h-[500px]' : 'max-h-0'} bg-white border-t border-[#E8E2D5]`}>
        <div className="container-tight py-6 flex flex-col gap-4">
          {links.map((l) => (
            <button key={l.id} onClick={() => scrollTo(l.id)} className="text-left py-2 text-[12px] tracking-[0.28em] uppercase font-medium">
              {l.label}
            </button>
          ))}
          <div className="flex items-center justify-between pt-4 border-t border-[#E8E2D5]">
            <button onClick={toggle} className="text-[11px] tracking-[0.2em] uppercase">
              <span className={lang === 'fr' ? 'text-[#1A1A1A]' : 'text-[#8A8275]'}>FR</span>
              <span className="mx-1 text-[#8A8275]">/</span>
              <span className={lang === 'en' ? 'text-[#1A1A1A]' : 'text-[#8A8275]'}>EN</span>
            </button>
            <button onClick={openBooking} className="btn-primary">{t.nav.book}</button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
